import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

/** Instance unique partagée par le provider React et la déconnexion globale (`performAppLogout`). */
export const msalInstance = new PublicClientApplication(msalConfig);
